import { useEffect, useState } from "react";

import apiPath from "../constants/apiPath";
import useRequest from "./useRequest";
import { Severty, ShowToast } from "../helper/toast";
import io from "socket.io-client";

const useNotification = () => {
  const api = {
    notificationList: apiPath.listMyNotification,
    notificationDelete: apiPath.deleteAllNotification,
    notificationRead: apiPath.readNotification,
    notificationUnread: apiPath.readNotification,
  };
  const { request } = useRequest();

  const [recentActivityNotifications, setRecentActivityNotifications] = useState([]);
  const [recentActivityNotificationsCount, setRecentActivityNotificationsCount] = useState(0);

  // Establish WebSocket connection
  // useEffect(() => {
  //   const socket = io('ws://13.50.128.33:6555',{
  //     query: {
  //       token: localStorage.getItem("token") // Include JWT token here
  //     },
  //   });

  //   // Event listener for receiving notifications
  //   socket.on('notification', (notification) => {
  //     // Update recent activity notifications with the received notification
  //     setRecentActivityNotifications(prevNotifications => [notification, ...prevNotifications]);
  //   });

  //   // Clean up the WebSocket connection when component unmounts
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  const fetchRecentActivityNotifications = () => {
    if (!api.notificationList) return;
    request({
      url: api.notificationList,
      method: "GET",
      onSuccess: (data) => {
        if (data?.status && data?.data) {
          setRecentActivityNotifications(data.data.data || data.data.list || []);
          setRecentActivityNotificationsCount(data.data.total || data.data.count || 0);
        }
      },
      onError: (error) => { },
    });
  };

  const deleteNotification = (id) => {
    let url;
    if (!!id) {
      url = api.notificationDelete + "/" + "one" + "/" + id;
    } else {
      url = api.notificationDelete + "/" + "all";
    }
    request({
      url: url,
      method: "POST",
      onSuccess: (data) => {
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          fetchRecentActivityNotifications();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
    });
  };

  const readNotification = (id) => {
    let url;
    if (!!id) {
      url = api.notificationRead + "/" + "one" + "/" + id;
    } else {
      url = api.notificationRead + "/" + "all";
    }
    request({
      url: url,
      method: "POST",
      onSuccess: (data) => {
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          fetchRecentActivityNotifications();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
    });
  };

  const unreadNotification = (id) => {
    let url;
    if (!!id) {
      url = api.notificationUnread + "/" + "one" + "/" + id;
    } else {
      url = api.notificationUnread + "/" + "all";
    }
    request({
      url: url,
      method: "POST",
      onSuccess: (data) => {
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          fetchRecentActivityNotifications();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
    });
  };

  return {
    recentActivityNotifications,
    recentActivityNotificationsCount,
    fetchRecentActivityNotifications,
    deleteNotification,
    readNotification,
    unreadNotification,
  };
};

export default useNotification;
